//dependencias
import React, { Component } from 'react';

//componentes
import PorcentajeMD from './porcentajeMD'

class Index extends Component {

    render(){
        return(
            <div>
                <PorcentajeMD />
            </div>
        );
    }

}
export default Index;